import { isIE } from './isUserAgent';

function addStyleClassForIeBrowser() {
    const isIeBrowser = isIE();
    const elementsForIeClass = document.querySelectorAll('[data-ie-class]');
    if (isIeBrowser.length) {
        elementsForIeClass.forEach(element => {
            element.classList.add(element.dataset.ieClass);
        });
    }
}

export { addStyleClassForIeBrowser };
